import React, { useState } from 'react';
import { ScrollContainer } from 'components';
import { Modal } from 'react-responsive-modal';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { history } from 'redux/actions/user';
import { zeroPad } from 'helper/utils';
import './index.scss';

const ModalName = 'ModalInfo';

const Info = ({ name, toggleModal }) => {
	const dispatch = useDispatch();
	const { localize, fetchHistories } = useSelector(
		(state) => ({
			localize: state.localize.event,
			fetchHistories: state.main.fetchHistories,
		}),
		shallowEqual
	);
	const [tab, setTab] = useState('info');
	const classActive = (current) => (tab === current ? 'active' : '');
	const closeModal = () => {
		setTab('info');
		toggleModal(ModalName);
	};
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-info`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			onClose={closeModal}
			blockScroll={false}
		>
			<div className="modal-content">
				<div className="tab">
					<div className="tab-header">
						<button
							onClick={() => setTab('info')}
							className={`btn btn-info ${classActive('info')}`}
							type="button"
							aria-label="info"
						>
							{localize?.txt_tab_info}
						</button>
						<button
							onClick={() => {
								if (fetchHistories) dispatch(history());
								setTab('history');
							}}
							className={`btn btn-History ${classActive('history')}`}
							type="button"
							aria-label="history"
						>
							{localize?.txt_tab_history}
						</button>
					</div>
					<div className="tab-content">
						<ScrollContainer>
							{tab === 'info' ? <Rules /> : <History />}
						</ScrollContainer>
					</div>
				</div>
			</div>
		</Modal>
	);
};

const Rules = () => {
	const localize = useSelector((state) => state.localize.event, shallowEqual);
	const legends = [
		[
			{
				id: 1,
				img: 'ico_info_exchange_token.png',
				txt: 'txt_legend_exchange',
				scale: true,
			},
			{
				id: 2,
				img: 'ico_info_spin_token.png',
				txt: 'txt_legend_spin',
				scale: true,
			},
		],
		[
			{
				id: 3,
				img: 'ico_info_move_forward.png',
				txt: 'txt_legend_foward',
			},
			{
				id: 4,
				img: 'ico_info_move_backward.png',
				txt: 'txt_legend_backward',
			},
		],
		[
			{
				id: 5,
				img: 'ico_info_question.png',
				txt: 'txt_legend_mystery',
			},
			{
				id: 6,
			},
		],
	];
	return (
		<div className="rules animated fadeIn">
			<h3>{localize?.txt_legend_title}</h3>
			<table>
				<tbody>
					{legends.map((legend, idx) => {
						return (
							<tr key={idx}>
								{legend.map((data) => {
									return (
										<td key={data.id}>
											<div className="text-group">
												<img
													alt=""
													style={data.scale ? { transform: 'scale(1.4)' } : {}}
													src={process.env.REACT_APP_CDN_URL + data.img}
												/>{' '}
												{localize[data.txt]}
											</div>
										</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
			<h3>{localize?.txt_info_title}</h3>
			<div dangerouslySetInnerHTML={{ __html: localize?.txt_info_desc }} />
		</div>
	);
};

const History = () => {
	const { histories, localize } = useSelector(
		(state) => ({
			histories: state.main.histories,
			localize: state.localize.event,
		}),
		shallowEqual
	);
	return (
		<div className="history animated fadeIn">
			{histories.length > 0 ? (
				<table>
					<thead>
						<tr>
							<th>{localize?.txt_head_date}</th>
							<th>{localize?.txt_head_activity}</th>
							<th>{localize?.txt_head_results}</th>
						</tr>
					</thead>
					<tbody>
						{histories.map((histori, idx) => {
							return <TableRow key={idx} data={histori} />;
						})}
					</tbody>
				</table>
			) : (
				<h3>{localize?.txt_empty}</h3>
			)}
		</div>
	);
};

const Names = {
	exchange_token: 'Exchange Token',
	spin_token: 'Spin Token',
};

const TableRow = ({ data }) => {
	const stringDate = Date.parse(data.created_at);
	const date = new Date(stringDate);
	return (
		<tr>
			<td>
				<p>
					{zeroPad(date.getDate())}.{zeroPad(date.getMonth() + 1)}.
					{zeroPad(date.getFullYear())}
				</p>
				<p>
					{zeroPad(date.getHours())}:{zeroPad(date.getMinutes())}:
					{zeroPad(date.getSeconds())}
				</p>
			</td>
			<td>{data.category}</td>
			<td>{Names[data.value] ?? data.value}</td>
		</tr>
	);
};

export default Info;
